import script from "./EnvSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./EnvSwitcher.vue?vue&type=style&index=0&id=3bfcbb36&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bfcbb36"]])

export default __exports__